import { createContext, useContext } from 'react';
import yup from 'yup';
import { FlowItemParameterRef } from '../../../model/flow.types';

export interface FlowItemFormContextValue {
  setValidationSchema(schema: yup.AnySchema | undefined): void;
  setParameterValue(
    ref: FlowItemParameterRef,
    value: unknown,
    shouldValidate?: boolean
  ): void;
}

const FlowItemFormContext = createContext<FlowItemFormContextValue | undefined>(
  undefined
);

const useFlowItemFormContext = (): FlowItemFormContextValue => {
  const val = useContext(FlowItemFormContext);
  return val as FlowItemFormContextValue;
};

export { FlowItemFormContext, useFlowItemFormContext };
